import React from 'react';
import { useMutation } from '@apollo/client';
import {
  DeleteUser,
  QueryUserAccountQuery
} from '../../../../graphql/generated/graphql';
import { ID } from '../../../../types/typeDef';
import { MyAccountBlock } from '../../../../components/molecules/Blocks/MyAccountBlock';
import { DELETE_USER } from 'graphql/mutation/user/deleteUser';
import { MY_ID } from 'helpers/user/authorization';
import { GET_PROF_DASHBOARD } from 'graphql/query/dashboardProf/dashboardQuery';
import { toast } from 'react-hot-toast';
import pages from 'routes/pages';
import useGoToPage from 'hooks/useGoToPage';

export interface AccountProfilProps {
  user: QueryUserAccountQuery['getUserAccount'];
}
interface DeleteUserMutation {
  deleteUser: DeleteUser;
}

const AccountProfile = ({ user }: AccountProfilProps) => {
  const goEspaceProf = useGoToPage(pages.ESPACE_PROF.path);
  const [deleteUserMutation, deleteMutationStatus] = useMutation<
    DeleteUserMutation
  >(DELETE_USER, {
    refetchQueries: [
      {
        query: GET_PROF_DASHBOARD,
        variables: {
          id: MY_ID
        }
      }
    ]
  });

  const onDeleteUser = async (id: ID) => {
    try {
      toast.loading('Suppression en cours...');
      const deleteUserResponse = await deleteUserMutation({
        variables: { userId: id }
      });
      toast.dismiss();
      const { name, deleted, reason } = deleteUserResponse.data.deleteUser;
      if (deleted) {
        toast.success('élève ' + name + ' supprimé 🗑️');
        goEspaceProf();
      } else {
        if (reason === 'professeur') {
          toast.error('Supprimer un professeur est impossible 👩‍🏫');
        } else if (reason === 'commande') {
          toast.error("L'élève à déjà éffectué une commande 📦");
        } else {
          toast.error('Le challenge est terminé 🏁');
        }
      }
    } catch (e) {
      toast.dismiss();
    }
  };

  return (
    <MyAccountBlock
      user={user}
      deleteLoading={deleteMutationStatus.loading}
      deleteUser={onDeleteUser}
    />
  );
};

export default AccountProfile;
